import { createRouter, createWebHistory } from 'vue-router'
import Layout from '@/layout'
import { pcRoutes } from './pc.js'
import { mRoutes } from './m.js'
import { isMobile } from '@/utils/common.js'

const currentRoutes = isMobile() ? pcRoutes : pcRoutes;
const routes = [
  {
    path: '',
    component: Layout,
    redirect: '/index',
    children: currentRoutes
  },
  {
    path: '/order-info',
    component: () => import('@/views/cart/order.vue'),
    hidden: true
  },
  {
    path: '/order-result',
    component: () => import('@/views/cart/result.vue'),
    hidden: true
  },
  {
    path: "/:pathMatch(.*)*",
    component: () => import('@/views/error/404.vue'),
    hidden: true
  },
  {
    path: '/401',
    component: () => import('@/views/error/401.vue'),
    hidden: true
  },
]

const router = createRouter({
	mode:'history',
	routes,
	history: createWebHistory(),
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return { top: 0 }
    }
  },
})

export default router
